import { CustomRouteRecordRaw } from 'vue-router'
import EmptyLayout from '@/views/layouts/empty-layout.vue'

export const miniAppRoutes: CustomRouteRecordRaw = {
  path: 'miniApp',
  name: 'miniApp',
  component: EmptyLayout,
  meta: {
    title: '小程序管理',
    icon: 'branches-outlined',
  },
  children: [
    {
      path: 'auths',
      name: 'auths',
      component: () => import('@/views/miniApp/auths.vue'),
      meta: {
        title: '已授权小程序',
      }
    },
    {
      path: 'detail/:id',
      name: 'miniAppDetail',
      component: () => import('@/views/miniApp/detail.vue'),
      meta: {
        title: '小程序详情',
        hideInMenu: true
      },
    },
  ]
}
